import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { allReviewsUrl } from '../../../components/Reviews/constants';
import { ProductContext } from '../context';
import { QUERY_LIMIT, QUESTIONS, REVIEWS } from './constants';
import css from './QuestionsAndReviews.module.scss';
import Form from '../Questions/Form';
import Header from './Header';
import ProductFitRatingQuestion from '../../../components/QuestionReviewsHeader/Question';
import Questions from '../Questions';
import Reviews from '../../../components/Reviews';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var QuestionsAndReviews = function QuestionsAndReviews(props) {
  var isPDP = props.isPDP,
      product = props.product;

  var _useState = useState(REVIEWS),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useInView = useInView({
    rootMargin: '350px 0px 0px 0px',
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      refInView = _useInView2[0],
      inView = _useInView2[1];

  var _useContext = useContext(ProductContext),
      showAskQuestion = _useContext.showAskQuestion,
      setShowAskQuestion = _useContext.setShowAskQuestion;

  var questionsActive = active.id === QUESTIONS.id;
  var reviewsActive = active.id === REVIEWS.id;

  var onAskQuestion = function onAskQuestion() {
    setShowAskQuestion(true);
  };

  var onCancelQuestion = function onCancelQuestion() {
    setShowAskQuestion(false);
  };

  return /*#__PURE__*/_jsx("div", {
    className: cc(css.wrap),
    children: /*#__PURE__*/_jsxs("div", {
      className: cc([css.root, _defineProperty({}, css.inView, inView)]),
      id: REVIEWS.id,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.headerWrap,
        children: /*#__PURE__*/_jsx(Header, {
          active: active,
          isPDP: isPDP,
          setActive: setActive
        })
      }), /*#__PURE__*/_jsx("div", {
        "aria-hidden": "true",
        className: css.inView,
        ref: refInView
      }), inView && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: cc([css.results, _defineProperty({}, css.active, reviewsActive)]),
          "aria-hidden": reviewsActive ? 'false' : 'true',
          "aria-label": "Reviews",
          id: "type-reviews",
          role: "tabpanel",
          tabIndex: "0",
          children: /*#__PURE__*/_jsx(Reviews, {
            onAskQuestion: onAskQuestion,
            onCancelQuestion: onCancelQuestion,
            colorways: product.colorways,
            fitRatingAvg: props.fitRatingAvg,
            ratingAvg: props.ratingAvg,
            reviewCount: props.reviewCount,
            reviewWithPhotoCount: props.reviewWithPhotoCount,
            shopifyId: product.shopifyId,
            title: product.title,
            isPDP: isPDP,
            queryLimit: QUERY_LIMIT,
            viewAllLink: allReviewsUrl(product.shopifyId)
          })
        }), /*#__PURE__*/_jsxs("div", {
          "aria-hidden": questionsActive ? 'false' : 'true',
          "aria-label": "Questions and Answers",
          className: cc([css.results, _defineProperty({}, css.active, questionsActive)]),
          id: "type-questions",
          role: "tabpanel",
          tabIndex: "0",
          children: [/*#__PURE__*/_jsx(ProductFitRatingQuestion, {
            colorways: product.colorways,
            fitRatingAvg: props.fitRatingAvg,
            onAskQuestion: onAskQuestion,
            onCancelQuestion: onCancelQuestion,
            questionsCount: props.questionsCount,
            ratingAvg: props.ratingAvg,
            reviewCount: props.reviewCount,
            shopifyId: product.shopifyId,
            title: product.title
          }), /*#__PURE__*/_jsx(Questions, {
            colorways: product.colorways,
            shopifyId: product.shopifyId,
            queryLimit: QUERY_LIMIT,
            onAskQuestion: onAskQuestion,
            onCancelQuestion: onCancelQuestion
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        "aria-hidden": showAskQuestion ? 'false' : 'true',
        children: /*#__PURE__*/_jsx(Form, {
          on: showAskQuestion,
          onAskQuestion: onAskQuestion,
          onCancelQuestion: onCancelQuestion,
          productId: product.id,
          title: product.title
        })
      })]
    })
  });
};

QuestionsAndReviews.defaultProps = {
  isPDP: true,
  questionsCount: 0
};
QuestionsAndReviews.propTypes = {
  isPDP: PropTypes.bool,
  fitRatingAvg: PropTypes.number,
  href: PropTypes.string,
  questionsCount: PropTypes.number,
  ratingAvg: PropTypes.number,
  reviewCount: PropTypes.number,
  reviewWithPhotoCount: PropTypes.number,
  product: PropTypes.shape({
    colorways: PropTypes.shape({}),
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    shopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired
};
export default QuestionsAndReviews;